const Role = {
  HR: 'Hr'
};

export default Role;
